import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'homepage',
        component: () => import(/* webpackChunkName: "Homepage" */ '../views/Homepage.vue')
    },
    {
        path: '/profiling',
        name: 'profiling',
        component: () => import(/* webpackChunkName: "OnBoarding" */ '../views/Profiling.vue')
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "PageNotFound" */ 'library-@/components/404/Main.vue')
    }
];

const router = new VueRouter({
    mode: 'hash',
    routes
});

export default router;
